import PastNotes from "modules/PastNotes/View";

import { ENotesEntity, EPipelineSlug } from "@type/api/management/types";

function BUFieldSalesPastNotes() {
  return (
    <PastNotes
      entityType={ENotesEntity.BUSINESS_UNIT}
      pipelineSlug={EPipelineSlug.FIELD_SALES}
    />
  );
}

export default BUFieldSalesPastNotes;
